import React, { useEffect, useState } from "react";
import style from "./style.module.css";
import IcSetaDireita from "../../components/Svg/IcSetaDireita";
import IcSetaEsquerda from "../../components/Svg/IcSetaEsquerda";
import Slct from "../Slct";
export default function Pagenation(props) {
  const { current = 1, total = 1, pageChange, className, ...other } = props;
  const [pages, setpages] = useState();
  useEffect(() => {
    let _pages = [];
    for (let __i = 0; __i < total; __i++) {
      _pages.push({ label: __i + 1, value: __i + 1 });
    }
    setpages(_pages);
  }, [total]);
  return (
    <div className={`${style.container} ${className}`} {...other}>
      <div
        className={`${style.pageIndex} ${current <= 1 ? "disabled" : ""}`}
        onClick={() => {
          pageChange(current - 1);
        }}
      >
        <span className={style.arrow}>
          <IcSetaEsquerda />
        </span>
      </div>
      <div className="d-flex flex-direction-column align-items-center">
        <span>Página: </span>
        <Slct
          options={pages || []}
          value={current || 1}
          onChange={__ev => {
            pageChange(__ev?.value);
          }}
          placeholder="..."
          menuPlacement="top"
          className="ml-2 mr-2"
        />
        <span>de {total}</span>
      </div>
      <div
        className={`${style.pageIndex} ${current >= total ? "disabled" : ""}`}
        onClick={() => {
          console.log("current", current + 1);
          pageChange(current + 1);
        }}
      >
        <span className={style.arrow}>
          <IcSetaDireita />
        </span>
      </div>
    </div>
  );
}
